import { memo, useMemo, useState } from "react";
import { Form, Text, useTheme, type Tab } from "react-better-html";

import { useI18n } from "../../../utils/i18n";

import Section from "../../../components/structure/Section";
import BubbleTabs from "../../../components/common/BubbleTabs";
import SettingItem from "./SettingItem";

function GeneralSection() {
   const theme = useTheme();
   const { t } = useI18n();

   const [weekStartDay, setWeekStartDay] = useState<string>("monday");
   const [measurementUnit, setMeasurementUnit] = useState<string>("metric");

   console.log(weekStartDay, measurementUnit);

   const weekStartDayTabs = useMemo<Tab[]>(
      () => [
         {
            id: "monday",
            label: t((l) => l.enums.dayOfWeek.monday),
         },
         {
            id: "sunday",
            label: t((l) => l.enums.dayOfWeek.sunday),
         },
      ],
      [t],
   );
   const measurementUnitTabs = useMemo<Tab[]>(
      () => [
         {
            id: "metric",
            label: t((l) => l.enums.measurementUnit.metric),
         },
         {
            id: "imperial",
            label: t((l) => l.enums.measurementUnit.imperial),
         },
      ],
      [t],
   );

   const isDirty = false;

   return (
      <Section
         title={t((l) => l.pages.settings.sections.general.title)}
         description={t((l) => l.pages.settings.sections.general.description)}
         disabled
      >
         <Form
            submitButtonText={t((l) => l.common.save)}
            submitButtonIsDisabled={!isDirty}
            renderActionButtons={
               !isDirty ? (
                  <Text fontSize={14} color={theme.colors.textSecondary} marginLeft={theme.styles.gap}>
                     {t((l) => l.components.form.nothingToSave)}
                  </Text>
               ) : undefined
            }
            withDividers
         >
            <SettingItem
               title={t((l) => l.pages.settings.sections.general.fields.weakStartDay)}
               description={t((l) => l.pages.settings.sections.general.fields.weakStartDayDescription)}
               rightElement={
                  <BubbleTabs
                     tabs={weekStartDayTabs}
                     backgroundColor={theme.colors.backgroundBase}
                     onChange={setWeekStartDay}
                  />
               }
            />

            <SettingItem
               title={t((l) => l.pages.settings.sections.general.fields.measurementUnit)}
               description={t((l) => l.pages.settings.sections.general.fields.measurementUnitDescription)}
               rightElement={
                  <BubbleTabs
                     tabs={measurementUnitTabs}
                     backgroundColor={theme.colors.backgroundBase}
                     onChange={setMeasurementUnit}
                  />
               }
            />
         </Form>
      </Section>
   );
}

export default memo(GeneralSection);
